import _asyncToGenerator from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/ecomm-marketplace/node_modules/@babel/runtime/regenerator/index.js";
/* eslint class-methods-use-this: 0 */

import _ from 'lodash';
import { priceCartComputer } from './price-cart-calculations';
import { serverSideComputations } from './legacy-calculations';
import { CALCULATION_PRICE_SERVICE } from 'shared/constants';
var OrderComputationsAsync = /*#__PURE__*/function () {
  function OrderComputationsAsync() {
    _classCallCheck(this, OrderComputationsAsync);
  }
  _createClass(OrderComputationsAsync, null, [{
    key: "compute",
    value: function () {
      var _compute = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _data$discountSyncEna;
        var data, logger, _ref$apolloClient, apolloClient, _ref$restApi, restApi, _ref$ddMetric, ddMetric, priceCartEnabled, priceService, calcOptions, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = _ref.data, logger = _ref.logger, _ref$apolloClient = _ref.apolloClient, apolloClient = _ref$apolloClient === void 0 ? null : _ref$apolloClient, _ref$restApi = _ref.restApi, restApi = _ref$restApi === void 0 ? null : _ref$restApi, _ref$ddMetric = _ref.ddMetric, ddMetric = _ref$ddMetric === void 0 ? null : _ref$ddMetric;
              priceCartEnabled = (_data$discountSyncEna = data.discountSyncEnabled) !== null && _data$discountSyncEna !== void 0 ? _data$discountSyncEna : false;
              priceService = data.priceService; // "ecomm-checkout", "plus-checkout", or "cart
              calcOptions = {
                logger: logger,
                apolloClient: apolloClient,
                restApi: restApi,
                ddMetric: ddMetric,
                priceService: priceService
              };
              if (!priceCartEnabled) {
                _context.next = 10;
                break;
              }
              _context.next = 7;
              return priceCartWrapper(data, calcOptions);
            case 7:
              response = _context.sent;
              _context.next = 13;
              break;
            case 10:
              _context.next = 12;
              return legacyWrapper(data, calcOptions);
            case 12:
              response = _context.sent;
            case 13:
              return _context.abrupt("return", response);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function compute(_x) {
        return _compute.apply(this, arguments);
      }
      return compute;
    }()
  }]);
  return OrderComputationsAsync;
}();
export { OrderComputationsAsync as default };
function legacyWrapper(_x2, _x3) {
  return _legacyWrapper.apply(this, arguments);
}
function _legacyWrapper() {
  _legacyWrapper = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, _ref2) {
    var logger, apolloClient, priceService, _data$dispensary;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          logger = _ref2.logger, apolloClient = _ref2.apolloClient, priceService = _ref2.priceService;
          _context2.prev = 1;
          _context2.next = 4;
          return serverSideComputations(data, logger, apolloClient, priceService);
        case 4:
          return _context2.abrupt("return", _context2.sent);
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](1);
          logger.error("Error in legacyWrapper | ".concat(priceService), {
            error: _context2.t0.message,
            dispensaryId: (_data$dispensary = data.dispensary) === null || _data$dispensary === void 0 ? void 0 : _data$dispensary.id
          });
          return _context2.abrupt("return", {});
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 7]]);
  }));
  return _legacyWrapper.apply(this, arguments);
}
function priceCartWrapper(_x4, _x5) {
  return _priceCartWrapper.apply(this, arguments);
}
function _priceCartWrapper() {
  _priceCartWrapper = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, _ref3) {
    var logger, apolloClient, restApi, ddMetric, priceService, priceCartResponse, legacyComputerResponse, errors, returnLegacy, _window, shouldLog;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          logger = _ref3.logger, apolloClient = _ref3.apolloClient, restApi = _ref3.restApi, ddMetric = _ref3.ddMetric, priceService = _ref3.priceService;
          priceCartResponse = {};
          legacyComputerResponse = {};
          errors = [];
          returnLegacy = false;
          _context3.prev = 5;
          _context3.next = 8;
          return priceCartComputer(data, logger, apolloClient, restApi, priceService);
        case 8:
          priceCartResponse = _context3.sent;
          if (!priceCartResponse.shouldFallback) {
            _context3.next = 21;
            break;
          }
          returnLegacy = true;
          _context3.prev = 11;
          _context3.next = 14;
          return legacyWrapper(data, {
            logger: logger,
            apolloClient: apolloClient,
            priceService: priceService
          });
        case 14:
          legacyComputerResponse = _context3.sent;
          _context3.next = 21;
          break;
        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](11);
          errors.push(_context3.t0);
          legacyComputerResponse = {};
        case 21:
          _context3.next = 38;
          break;
        case 23:
          _context3.prev = 23;
          _context3.t1 = _context3["catch"](5);
          errors.push(_context3.t1);
          priceCartResponse = {
            error: _context3.t1
          };
          returnLegacy = true;
          _context3.prev = 28;
          _context3.next = 31;
          return legacyWrapper(data, {
            logger: logger,
            apolloClient: apolloClient,
            priceService: priceService
          });
        case 31:
          legacyComputerResponse = _context3.sent;
          _context3.next = 38;
          break;
        case 34:
          _context3.prev = 34;
          _context3.t2 = _context3["catch"](28);
          errors.push(_context3.t2);
          legacyComputerResponse = {};
        case 38:
          _context3.prev = 38;
          if (typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && _window._____APP_STATE_____) {
            // the legacy response gets added in computations_calcs.js, as "debugging.calculations"
            _.set(window._____APP_STATE_____, 'debugging.priceCartCalculations', priceCartResponse);
          }
          // we want to log if the cart is not empty, or if there are errors, or if the price cart timed out
          shouldLog = cartIsNotEmpty(priceCartResponse) || cartIsNotEmpty(legacyComputerResponse) || errors.length > 0 || priceCartResponse.timedOut;
          if (shouldLog) {
            afterCalculations({
              logger: logger,
              ddMetric: ddMetric,
              priceService: priceService,
              errors: errors,
              timedOut: priceCartResponse.timedOut
            });
          }
          return _context3.finish(38);
        case 43:
          return _context3.abrupt("return", returnLegacy ? legacyComputerResponse : priceCartResponse);
        case 44:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[5, 23, 38, 43], [11, 17], [28, 34]]);
  }));
  return _priceCartWrapper.apply(this, arguments);
}
function afterCalculations(_ref4) {
  var logger = _ref4.logger,
    ddMetric = _ref4.ddMetric,
    priceService = _ref4.priceService,
    errors = _ref4.errors,
    timedOut = _ref4.timedOut;
  var metricName = "dutchie.ecomm.price-cart-calculations";
  var shouldLogMetric = priceService !== CALCULATION_PRICE_SERVICE.cart;
  if (timedOut) {
    if (shouldLogMetric) {
      ddMetric().increment(metricName.concat('.timeout'), {
        env: process.env.APP_ENV,
        priceService: priceService
      });
    }
    return;
  }
  if (_.size(errors) > 0) {
    _.forEach(errors, function (error) {
      logger.error("Errors in async calculations | ".concat(priceService), error);
    });
    if (shouldLogMetric) {
      ddMetric().increment(metricName.concat('.error'), {
        env: process.env.APP_ENV,
        priceService: priceService
      });
    }
  }
}
function cartIsNotEmpty(response) {
  var _response$receipt;
  return _.some(response === null || response === void 0 || (_response$receipt = response.receipt) === null || _response$receipt === void 0 ? void 0 : _response$receipt.summary, function (value) {
    return value !== 0;
  });
}